export { default } from './SingleSelect'
